import Nullstack from 'nullstack';
export default function IconSlideshow({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-slideshow",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "15",
    y1: "6",
    x2: "15.01",
    y2: "6"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "14",
    rx: "3"
  }), "   ", Nullstack.element("path", {
    d: "M3 13l4 -4a3 5 0 0 1 3 0l4 4"
  }), "   ", Nullstack.element("path", {
    d: "M13 12l2 -2a3 5 0 0 1 3 0l3 3"
  }), "   ", Nullstack.element("line", {
    x1: "8",
    y1: "21",
    x2: "8.01",
    y2: "21"
  }), "   ", Nullstack.element("line", {
    x1: "12",
    y1: "21",
    x2: "12.01",
    y2: "21"
  }), "   ", Nullstack.element("line", {
    x1: "16",
    y1: "21",
    x2: "16.01",
    y2: "21"
  }), " ");
}